import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    onlineUsers: []
};

const getters = {
    getOnlineUsers: (state) => state.onlineUsers
};

const actions = {
    async getAllOnlineUsers( context, data ) {
        await axios.post(`${backendUrl()}/getAllOnlineUsers`,
            {
                requesterLevel: context.getters.getUserLevel,
                currentPage: data.currentPage,
                perPage: data.perPage
            },
            {
                headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
            })
            .then(response => {
                context.commit('setOnlineUsers', response.data.allOnlineUsers)
            })
    }
};

const mutations = {
    setOnlineUsers:(state, onlineUsers) => (state.onlineUsers = onlineUsers)
};

export default {
    state,
    getters,
    actions,
    mutations
}
